<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Email content</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Email content Text Prompt</p>
      </div>

      <Form v-slot="{ handleSubmit, errors}" :validation-schema="schema" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <button v-if="dataId" @click="destroy" type="button" class="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3">
          <TrashIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <div class="px-4 py-6 sm:p-8">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            <div  class="sm:col-span-5">
              <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                Type
              </label>
              <Field :disabled="dataId" v-model="formData.type" v-bind:class="{ 'ring-red-600': errors.type, 'cursor-not-allowed': dataId }" as="select" name="type" id="type" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                <option v-for="(title, id) in emailTemplateTypesList" :value="id" :key="id" v-bind:selected="id === formData.type">
                  {{ title }}
                </option>
              </Field>
              <ErrorMessage class="mt-2 text-xs text-red-600" name="type" />
            </div>

            <template v-if="formData.type === 'p' || formData.type === 'button'">
              <div class="sm:col-span-5">
                <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                  Content text
                  <span class="text-red-600 text-sm">*</span>
                </label>
                <div class="mt-2">
                  <Field v-model="formData.content_text" v-bind:class="{ 'ring-red-600': errors.content_text }" as="textarea" name="content_text" id="content_text" placeholder="Content text" rows="6" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                  <ErrorMessage class="mt-2 text-xs text-red-600" name="content_text" />
                </div>
              </div>

              <div class="sm:col-span-5" v-if="formData.type === 'button'">
                <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                  Link or dynamic content link
                </label>
                <div class="mt-2">
                  <Field v-model="formData.content_href" v-bind:class="{ 'ring-red-600': errors.content_href }" type="text" name="content_href" id="content_href" placeholder="Content href" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                  <ErrorMessage class="mt-2 text-xs text-red-600" name="content_href" />
                </div>
              </div>
            </template>

            <template v-if="formData.type === 'image'">
              <div class="sm:col-span-5">
                <label for="image_file" class="block text-sm font-medium leading-6 text-gray-900">
                  Image
                </label>
                <div class="mt-2 flex items-center space-x-4">

                  <img v-if="previewImage" :src="previewImage" alt="Image File" class="">
                </div>
                <div class="mt-2 flex items-center space-x-4">
                  <button @click="selectImageFile" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                    Select Image File
                  </button>

                  <input type="file" ref="imageFileInput" @change="handleImageFileChange" accept="image/*" class="hidden">
                </div>
              </div>

              <div class="sm:col-span-5">
                <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                  Alt text image
                  <span class="text-red-600 text-sm">*</span>
                </label>
                <div class="mt-2">
                  <Field v-model="formData.content_text" v-bind:class="{ 'ring-red-600': errors.content_text }" as="textarea" name="content_text" id="content_text" placeholder="Content text" rows="6" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                  <ErrorMessage class="mt-2 text-xs text-red-600" name="content_text" />
                </div>
              </div>
            </template>

            <div class="sm:col-span-5">
              <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                Order
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field v-model="formData.order" v-bind:class="{ 'ring-red-600': errors.order }" type="number" name="order" id="order" placeholder="Order" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="order" />
              </div>
            </div>

          </div>

        </div>
        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button @click="cancel" type="button" class="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
          <button v-if="dataId" @click="handleSubmit($event, update)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Update</button>
          <button v-else @click="handleSubmit($event, create)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Save</button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { TrashIcon } from '@heroicons/vue/24/solid'

export default {
  name: "EmailTemplateEditFormComponent",

  props: {
    dataId: {
      type: Number,
      required: false,
    },
    emailTemplateId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      formData: {
        content_text: null,
        type: 'p',
        order: 0,
        content_href: null,
        image_file: null,
        content_css: {
          width: '',
        },
      },
      emailTemplateTypesList: {
        'p': 'p',
        'button': 'button',
        'image': 'image',
      },
      previewImage: null,
    }
  },
  components: {
    TrashIcon,
  },
  computed: {
    schema() {
      return yup.object({
        content_text: yup.string().required().min(3).label('Content text'),
        order: yup.number().required().label('Order'),
      });
    },
    isAdmin() {
      return this.$store.state.userIsAccountLevelAdmin;
    },
  },
  methods: {
    getEmailTemplateContent() {
      axios.get(`/member-firm/email-templates/edit/${this.dataId}`).then((res) => {
        this.formData = res.data.data;
        this.previewImage = this.formData.base_url + this.formData.content_href;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    update() {
      axios.post(
          `/member-firm/email-templates/update/${this.dataId}`,
          this.formData,
          {
            headers: {'Content-Type': 'multipart/form-data'},
            params: {_method: 'PUT'}
          }
      ).then((res) => {
        this.$emit('reloadIndex');
        this.$notify({ type: "success", title: "Successfully", text: res.data.message });
        this.$emit('cancel');
      }).catch((error) => {
        console.log('error', error);
        this.$emit('reloadIndex');
        this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    create() {
      axios.post(
          `/member-firm/email-templates/store/${this.emailTemplateId}`,
          this.formData,
          {headers: {'Content-Type': 'multipart/form-data'}}
      ).then((res) => {
          this.$emit('reloadIndex');
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.$emit('cancel');
      }).catch((error) => {
          console.log('error', error);
          this.$emit('reloadIndex');
          this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    cancel() {
      this.$emit('cancel');
    },
    destroy() {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/email-templates/destroy/${this.dataId}`).then((res) => {
          this.$emit('cancel');
          this.$emit('reloadIndex');
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
          this.$emit('reloadIndex');
        })
      }
    },
    handleImageFileChange() {
      const fileInput = this.$refs.imageFileInput;

      if (fileInput.files.length > 0) {
        this.formData.image_file = fileInput.files[0];

        if (this.formData.image_file) {
          let reader = new FileReader
          reader.onload = e => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(this.formData.image_file)
          this.$emit('input', this.formData.image_file)
        }
        console.log(this.formData);
      }
    },
    selectImageFile() {
      const fileInput = this.$refs.imageFileInput;
      if (fileInput) {
        fileInput.click();
      }
    },
  },
  created() {
    if(this.dataId){
      this.getEmailTemplateContent();
    }
  }
}
</script>
